import type { AppRouteConfig } from '../../models'
import { FeatureIdEnum } from '../../enums'
import Account from '../../views/account.view.vue'
import { ROUTER_CONSTS } from '../router.consts'

export const ACCOUNT_ROUTES: Array<AppRouteConfig> = [
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.ACCOUNT],
    path: 'account',
    component: Account,
    meta: {
      featureId: FeatureIdEnum.ACCOUNT,
    },
  },
]
